import { Box, MenuItem, Stack, TextField, Typography } from '@mui/material'
import { useMemo, useState } from 'react'

import { useGetSaleReferenceRowsQuery } from '../../store/api/saleContractApi'

import SaleReferenceGrid from './SaleReferenceGrid'
import {
  SALE_REFERENCE_PAGE_CONFIGS,
  SALE_REFERENCE_PAGE_ORDER,
  type SaleReferencePageKey,
} from './saleReferenceConfig'

export default function SaleReferencesView() {
  const [pageKey, setPageKey] = useState<SaleReferencePageKey>('ValueUpdates')
  const [searchByPage, setSearchByPage] = useState<Partial<Record<SaleReferencePageKey, string>>>({})

  const page = SALE_REFERENCE_PAGE_CONFIGS[pageKey]
  const search = searchByPage[pageKey] ?? ''

  const queryArg = useMemo(
    () => ({
      pageKey,
      limit: page.limit ?? 5000,
    }),
    [page.limit, pageKey],
  )

  const { data, isLoading, error, refetch } = useGetSaleReferenceRowsQuery(queryArg)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, minHeight: 0, flex: 1 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        flexWrap="wrap"
        gap={1}
        sx={{ px: 0.25 }}
      >
        <Box>
          <Typography
            variant="h6"
            fontWeight={700}
            sx={{ fontSize: '1rem', lineHeight: 1.4 }}
          >
            Sale References
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: '0.8rem' }}
          >
            Access switchboard parity for the 13 reference pages.
          </Typography>
        </Box>
        <Stack alignItems="flex-end" spacing={0.5}>
          <TextField
            select
            label="Go to Page"
            size="small"
            value={pageKey}
            onChange={(e) => setPageKey(e.target.value as SaleReferencePageKey)}
            sx={{
              minWidth: 240,
              '& .MuiInputBase-input': { fontSize: '0.8rem' },
              '& .MuiInputLabel-root': { fontSize: '0.8rem' },
            }}
          >
            {SALE_REFERENCE_PAGE_ORDER.map((key) => (
              <MenuItem key={key} value={key}>
                {SALE_REFERENCE_PAGE_CONFIGS[key].label}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
      </Stack>

      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 0, flex: 1 }}>
        <SaleReferenceGrid
          page={page}
          rows={data?.items ?? []}
          search={search}
          onSearchChange={(value) =>
            setSearchByPage((prev) => ({
              ...prev,
              [pageKey]: value,
            }))
          }
          loading={isLoading}
          error={error}
          onRetry={() => {
            void refetch()
          }}
        />
      </Box>
    </Box>
  )
}
